/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Amenitiesshowmore2Inputs */

const en_amenitiesshowmore2 = /** @type {(inputs: Amenitiesshowmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show more (+${i?.count})`)
};

const de_amenitiesshowmore2 = /** @type {(inputs: Amenitiesshowmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mehr anzeigen (+${i?.count})`)
};

/**
* | output |
* | --- |
* | "Show more (+{count})" |
*
* @param {Amenitiesshowmore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const amenitiesshowmore2 = /** @type {((inputs: Amenitiesshowmore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Amenitiesshowmore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_amenitiesshowmore2(inputs)
	return de_amenitiesshowmore2(inputs)
});
export { amenitiesshowmore2 as "amenitiesShowMore" }